import { ReactNode, ReactElement } from "react";

import { Icon, IconVariant } from "_/components/icon";
import { t } from "@lingui/core/macro";

import * as S from "./styled";

export const Notice = ({
  kind,
  children,
}: {
  kind: "caution" | "warning" | "notice" | "tip";
  children: ReactNode;
}): ReactElement => {
  let bgColor = "rgba(0, 0, 0, 0.0)";
  let label = "";
  let icon: IconVariant = "Info";

  // TODO: Replace these colors with color theme colors.
  // TODO: Use l10n for these labels.
  // TODO: Re-evaluate these icons.
  switch (kind) {
    case "notice":
      bgColor = "#14294f";
      label = t`docs-view.notice`;
      icon = "Info";
      break;
    case "caution":
      bgColor = "#876507";
      label = t`docs-view.caution`;
      icon = "Warning";
      break;
    case "warning":
      bgColor = "#6e2215";
      label = t`docs-view.warning`;
      icon = "Warning";
      break;
    case "tip":
      bgColor = "#2052ec";
      label = t`docs-view.tip`;
      icon = "Info";
      break;
  }

  return (
    <S.Notice $bgColor={bgColor}>
      <S.NoticeHeader>
        <Icon variant={icon} label={label} />
        {label !== "" && <S.NoticeTitle>{label}</S.NoticeTitle>}
      </S.NoticeHeader>
      {children}
    </S.Notice>
  );
};
